// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__1Kkfp","load6":"Spinner_load6__2iUd_","round":"Spinner_round__2_bYR"};